import React, { Component } from "react";
import NewUserModalService from "./NewUserModal.service";
import IconInput from "./../../../Shared/IconInput";
import SuccessAlert from "./../../../Shared/SuccessAlert";
import "./NewUserModal.scss";
import userp from "../../../../assets/image/icon/profile black.png";
import {
  STATUS_NOT_FOUND,
  STATUS_CONFLICT,
  STATUS_FORBIDDEN,
} from "../../../../config";

export default class NewUserModal extends Component {
  state = {
    usernameIsInvalid: false,
    username: undefined,
    success: false,
    isLoading: false,
  };

  shareBookmarks = () => {
    if (!this.state.username || this.state.username === "") return;

    this.setState({
      isLoading: true,
    });

    NewUserModalService.shareBookmarks(
      this.state.username,
      this.props.userInfo.username,
      this.props.userInfo.token
    )
      .then((user) => {
        this.props.addUserShared(user);
        this.setState({
          success: true,
        });
        setTimeout(() => {
          this.props.close();
        }, 2500);
      })
      .catch((error) => {
        if (
          error.response.status === STATUS_NOT_FOUND ||
          error.response.status === STATUS_CONFLICT ||
          error.response.status === STATUS_FORBIDDEN
        ) {
          // Username found
          this.setState({
            usernameIsInvalid: error.response.data.error,
          });
        } else {
          this.props.alert({
            theme: "error",
            message: error.message,
          });
        }
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  };

  onNewUsernameValue = (e) => {
    if (this.state.usernameIsInvalid)
      this.setState({
        usernameIsInvalid: false,
      });
    if (e.key === "Enter") {
      this.shareBookmarks();
    } else {
      this.setState({
        username: e.target.value,
      });
    }
  };

  onKeyPress = (e) => {
    if (e.key === "Enter") {
      this.shareBookmarks();
    }
  };

  render() {
    return (
      <div className="modal-thing">
        {this.state.success ? <SuccessAlert message="Bookmarks shared!" /> : ""}
        <div className="p-4">
          <span className="badge">Share bookmarks with:</span>
          <IconInput
            onKeyPress={this.onKeyPress}
            placeholder="Username or Email"
            disabled={this.state.isLoading}
            isInvalid={this.state.usernameIsInvalid}
            onValueChange={this.onNewUsernameValue}
            icon={userp}
          >
            <button
              className="btn btn-primary btn-share"
              onClick={this.shareBookmarks}
              disabled={this.state.isLoading}
            >
              {this.state.isLoading ? (
                <div
                  id="btn-login-spinner"
                  className="spinner-border spinner-border-sm text-light"
                  role="status"
                >
                  <span className="sr-only">Loading...</span>
                </div>
              ) : (
                "Share"
              )}
            </button>
          </IconInput>
        </div>
      </div>
    );
  }
}
